import React from 'react';

import { getRawDigInDecimal, getIsDigInRisk, getDigInPercent } from '../../../utils/helpers';

const DigInSummaryItem = ({ ticket }) => {
  const rawDigInPercent = getRawDigInDecimal(ticket);
  const digInPercent = getDigInPercent(rawDigInPercent);
  const displayDigIn = digInPercent === -1 ? 'Not available' : `${digInPercent}%`;
  const docType = ticket && ticket.docType;
  const isDigInRisk = getIsDigInRisk(rawDigInPercent);
  const spanStyle = isDigInRisk ? { color: '#FD9717' } : {};

  if (process.env.REACT_APP_DIG_IN_MODEL === 'false') return null;

  return (
    docType === 'ticket' && (
      <div className="summary-item">
        Predicted dig-in risk
        <span style={spanStyle}>{displayDigIn}</span>
      </div>
    )
  );
};

export default DigInSummaryItem;
